import React, { Component } from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import { BoxDanger, BoxInfo, MnemoLoading, SupportoTecnicoLive, Title } from 'components/misc';
import { dateHelper, lessonOnSiteService, networkErrorHelper } from 'libs';
import { Button, Card, CardTitle, CardBody, Icon } from 'design-react-kit';
import { ROUTES } from 'const';

class LessonOnSiteDetail extends Component {

    state = {
        rCode: '',
        idLessonOnSite: 0,
        loading: true,
        loadingError: false,
        userCourse: null,
        lessonOnSite: null,
        fileSlides: null,
        lessonOnSiteAttendance: null,
    }

    loadRemote(id, rCode) {

        this.setState({ loading: true, loadingError: false });
        lessonOnSiteService
            .myOnSite(id, rCode)
            .then(({ data }) => {

                const { userCourse, lessonOnSite, fileSlides, lessonOnSiteAttendance } = data.payload;
                this.setState({
                    userCourse,
                    lessonOnSite,
                    fileSlides,
                    lessonOnSiteAttendance,
                    loading: false,
                });
            })
            .catch(error => {
                if (!networkErrorHelper.is404(error)) {
                    networkErrorHelper.notify(error);
                }

                this.setState({ loadingError: true, loading: false });
            });
    }

    componentDidMount() {
        const { idLessonOnSite, rCode } = this.props.match.params;
        this.setState({
            idLessonOnSite,
            rCode
        });

        this.loadRemote(idLessonOnSite, rCode);
    }

    generateAttendee = () => {
        this.setState({ loading: true });
        const { idLessonOnSite, rCode } = this.state;
        lessonOnSiteService.generateAttendance({ idLessonOnSite, registrationCode: rCode })
            .then(({ data }) => {
                this.setState({
                    lessonOnSiteAttendance: data.payload.lessonOnSiteAttendance,
                    loading: false

                });
            })
            .catch(error => {
                this.setState({ loading: false });
                networkErrorHelper.notify(error);
            });
    }

    downloadAttendee = () => {

        const { lessonOnSiteAttendance } = this.state;
        if (lessonOnSiteAttendance) {
            this.setState({ loading: true });
            lessonOnSiteService.donwloadAttendance(lessonOnSiteAttendance.id)
                .then(({ data }) => {
                    this.setState({ loading: false });
                    // window.location = lessonOnSiteAttendance.location;
                    window.open(lessonOnSiteAttendance.location, '_blank');
                })
                .catch(error => {
                    this.setState({ loading: false });
                    networkErrorHelper.notify(error);
                });
        }
    }

    openFile(file) {
        const { rCode } = this.state;
        const location = `${ROUTES.COURSE_SHOW_FILE}/${rCode}/${file.id}`;
        window.location = location;
    };

    downloadFile(file) {

        window.location = file.location;
    };

    getLocation = (onsite) => {

        let location = '';

        // verify if the lcoation exists by region 
        if (onsite.location) {
            if (this.state.userCourse?.pluginConfig?.region) {

                const tLocaltion = JSON.parse(onsite.location);
                location = tLocaltion[this.state.userCourse.pluginConfig.region.toUpperCase()];
            } else {

                // show the first location if the region is not set
                const tLocaltion = JSON.parse(onsite.location);
                const keys = Object.keys(tLocaltion);
                location = tLocaltion[keys[0]];
            }
        }

        return location;
    };

    render() {
        const {
            lessonOnSite, fileSlides,
            loading, loadingError, userCourse,
            lessonOnSiteAttendance } = this.state;

        let creditRecognition = false;
        if (userCourse && userCourse.creditRecognition) {
            creditRecognition = userCourse.creditRecognition;
        }
        
        return (
            <>
                <div>
                    <NavLink to='#' onClick={(e) => {
                        e.preventDefault();
                        window.history.back();
                    }} className="mx-5 btn btn-outline-primary float-right">
                        <Icon icon="it-presentation" /> TORNA INDIETRO</NavLink>
                    <Title >Lezione in presenza</Title>
                </div>
                {loading ? <MnemoLoading className="mt-5" /> : (

                    <div className='p-5'>
                        {loadingError && (<>
                            <BoxDanger className="mt-4">
                                Si è verificato un errore durante il caricamento della lezione. <SupportoTecnicoLive courseCode={userCourse.courseCode} />
                            </BoxDanger>
                        </>)}
                        {lessonOnSite && (
                            <div>
                                <Card noWrapper={false} tag="div" className="card-bg card-big rounded shadow border-bottom-card mb-5">
                                    <div className="flag-icon" />
                                    <div className="etichetta">
                                        <span >ATTIVITA'</span>
                                    </div>
                                    <CardBody tag="div">
                                        <CardTitle tag="h5">{lessonOnSite.title}</CardTitle>
                                        <ul>
                                            <li><b>Tutor:</b> {lessonOnSite.teacher}</li>
                                            <li><b>Data:</b> {dateHelper.toITDate(lessonOnSite.date)}</li>
                                            <li><b>Ora inizio:</b> {dateHelper.toShortTime(lessonOnSite.hourStart)}</li>
                                            <li><b>Ora fine:</b> {dateHelper.toShortTime(lessonOnSite.hourEnd)}</li>
                                            <li><b>Argomento:</b> {lessonOnSite.subject}</li>
                                            <li><b>Sede:</b> {this.getLocation(lessonOnSite)}</li>
                                        </ul>
                                        {lessonOnSite.note && (
                                            <BoxInfo
                                             className="my-2">
                                                <p><b>{lessonOnSite.note}</b> </p>
                                            </BoxInfo>
                                        )}
                                    </CardBody>
                                </Card>
                                <Card noWrapper={false} tag="div" className="card-bg card-big rounded shadow border-bottom-card mb-5">
                                    <div className="flag-icon" />
                                    <div className="etichetta">
                                        <span>MATERIALE DIDATTICO</span>
                                    </div>
                                    <CardBody tag="div">
                                        {(fileSlides && fileSlides.length) > 0 ?
                                            <>
                                                {fileSlides.map((file, index) => (

                                                    <BoxInfo className="my-0 mnemo-dopzone-boxInfo" key={`file-${file.id}`}>
                                                        {file.originalName}
                                                        <Button
                                                            className="mx-1"
                                                            color="primary bg-dark"
                                                            size="xs"
                                                            onClick={() => this.downloadFile(file)}>
                                                            Scarica
                                                        </Button>
                                                    </BoxInfo>
                                                ))
                                                }
                                            </>
                                            :
                                            <><p>Nessuna materiale didattico caricato</p></>}
                                    </CardBody>
                                </Card>
                                {(lessonOnSite.hasAttendance) && (
                                    <Card noWrapper={false} tag="div" className="card-bg card-big rounded shadow border-bottom-card mb-5">
                                        <div className="flag-icon" />
                                        <div className="etichetta">
                                            <span >ATTESTATO DI PARTECIPAZIONE</span>
                                        </div>
                                        {(creditRecognition && lessonOnSite.creditRecognition && lessonOnSite.creditRecognition.includes(creditRecognition)) ? (<>
                                            <p className="btn btn-outline-primary m-1">Attività non frequentata a seguito di riconoscimento</p>
                                        </>) : (<>
                                            < CardBody tag="div">
                                                {lessonOnSite.enableAttendance ?
                                                    <>

                                                        {(lessonOnSiteAttendance ? <>
                                                            <p>Attestato di partecipazione generato il {dateHelper.toITDate(lessonOnSiteAttendance.dateGeneration)}. Scaricato {lessonOnSiteAttendance.countDownload} volte.</p>
                                                            <Button onClick={this.downloadAttendee} >Scarica attestato di partecipazione</Button>
                                                        </> : <>
                                                            <Button onClick={this.generateAttendee} >Genera attestato di partecipazione</Button>
                                                        </>)}
                                                    </> : <p>Attestato di partecipazione non ancora disponibile</p>
                                                }
                                            </CardBody>
                                        </>)}

                                    </Card>
                                )}
                            </div>
                        )}
                    </div >
                )}
            </>
        );
    }
}
export default withRouter(LessonOnSiteDetail);
